var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('el-cascader',{attrs:{"props":_vm.props,"clearable":"","filter-method":_vm.handleFilter},on:{"change":_vm.handleChange},model:{value:(_vm.area),callback:function ($$v) {_vm.area=$$v},expression:"area"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }